<template>
  <div>
    <DialogContainer v-model="dialogObj">
      <template v-slot:dialogSlot>
        <div class="business-body custom-form">
          <div class="tab-box">
            <el-input clearable style="width: 4rem;margin-right: 0.1rem" placeholder="请输入司机姓名或车牌号码搜索" v-model="searchForm.keyword" type="text"></el-input>
            <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
            <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
          </div>
          <div class="custom-table-box1">
            <custom-table
              :data="tableData"
              :column="tableColumn"
              :total="tableOptions.total"
              :loading="tableOptions.loading"
              :page="tableOptions.pageNumber"
              :size="tableOptions.pageSize"
              :selection="false"
              @pagination="handleSizeChange">

              <template v-slot:operation="{ row }">
              <span class="color526bec" style="cursor: pointer" @click="handleRen(row)" v-if="row.canClaim">
                 认领
              </span>
              <span class="color526bec" style="cursor: pointer" @click="handleCancelRen(row)" v-if="row.canCancel">
                 取消认领
              </span>
              </template>
            </custom-table>
          </div>
        </div>
      </template>
    </DialogContainer>
  </div>

</template>

<script>
import CustomTable from "@/components/CustomTable.vue";
import DialogContainer from "@/components/Dialog.vue";
import { claimDriver, claimDriverCancel, claimDriverPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
export default {
  name: "Detail",
  mixins: [tableMixin],
  components: {
    CustomTable,
    DialogContainer
  },
  data() {
    return {
      getTableMethod: claimDriverPage,
      isImmediatelyGetData: false,
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "60%",
        show: false,
        title: "认领司机",
        closeOnClickModal: false,
        confirmFn: null,
        beforeClose: (v) => {
          this.$emit('refreshMyDriverList');
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      searchForm: {
        keyword: ""
      },
      tableColumn: [
        {
          label: "服务商名称",
          prop: "companyName",
          show: true,
        },
        {
          label: "司机姓名",
          prop: "username",
          show: true,
        },
        {
          label: "车牌号码",
          prop: "carNumber",
          show: true,
        },
        {
          label: "今日派单调度",
          prop: "dispatcherName",
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          width: "120px",
          scopeStatus: true,
          show: true,
        },
      ],
    };
  },
  mounted() {},
  methods: {
    init(driverId) {
      this.searchForm.driverId = driverId
      this.getTableData()
      this.dialogObj.show = true;
    },
    // 认领
    handleRen(row) {
      claimDriver({ driverId: row.driverId }).then((res) => {
        if (res.code === 200) {
          this.$message.success("认领成功");
          // this.$emit('refreshMyDriverList');
          this.getTableData()
        }
      });
    },
    // 取消认领
    handleCancelRen(row) {
      claimDriverCancel({ driverId: row.driverId }).then((res) => {
        if (res.code === 200) {
          this.$message.success("取消认领成功");
          // this.$emit('refreshMyDriverList');
          this.getTableData()
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  .tab-box {
    display: flex;
    background-color: #ffffff;
    padding: 0.1rem 0;
    span{
      padding: 0 0.1rem;
      font-size: 0.16rem;
    }
  }
  .custom-table-box1 {
    box-sizing: border-box;
    background: #f7f8fb;
    margin-bottom: 0.2rem;
    border-radius: 0.08rem;
    padding: 0.1rem;


    ::v-deep .el-table .cell {
      line-height: 0.3rem;
    }
  }
}
</style>
